import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "d-flex gap-2 mb-5 border-bottom",
  style: {"border-color":"var(--bs-gray-humo2) !important"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bank2 fs-3 text-info" }, null, -1)
const _hoisted_3 = { class: "h4 text-fprimary mb-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = {
  class: "d-flex gap-2 mb-5 border-bottom",
  style: {"border-color":"var(--bs-gray-humo2) !important"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person fs-3 text-info" }, null, -1)
const _hoisted_15 = { class: "h4 text-fprimary mb-3" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-sm-6" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = {
  class: "d-flex gap-2 mb-5 border-bottom",
  style: {"border-color":"var(--bs-gray-humo2) !important"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-check fs-3 text-info" }, null, -1)
const _hoisted_27 = { class: "h4" }
const _hoisted_28 = { class: "bg-white" }
const _hoisted_29 = { class: "row text-white bg-opacity-75 bg-navy rounded-top" }
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = { class: "d-inline-block p-3" }
const _hoisted_32 = { class: "col-sm-6" }
const _hoisted_33 = { class: "d-inline-block p-3" }
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = { class: "d-inline-block p-2" }
const _hoisted_36 = { class: "col-sm-6" }
const _hoisted_37 = {
  key: 0,
  class: "bi bi-check-lg h1 text-primary"
}
const _hoisted_38 = {
  key: 1,
  class: "bi bi-x-lg h3 text-fsecondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref: "formQRef",
      model: _ctx.formQ,
      rules: _ctx.rules,
      "label-position": "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.t("nusf1")), 1)
        ]),
        _createVNode(_component_el_form_item, {
          prop: "idinstitution",
          class: "mb-4",
          label: _ctx.t('nusf'),
          rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formQ.idinstitution,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formQ.idinstitution) = $event)),
              placeholder: "Institución",
              class: "w-100",
              size: "default"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  value: _ctx.formQ.idinstitution,
                  label: _ctx.formQ.business
                }, null, 8, ["value", "label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              prop: "country",
              class: "mb-4",
              label: _ctx.t('country'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formQ.country,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formQ.country) = $event)),
                  filterable: "",
                  placeholder: "Pais/Región",
                  class: "w-100",
                  size: "default"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: `lr-${item.idcountry}`,
                        label: `${item.idcountry} - ${item.name}`,
                        value: item.idcountry
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_form_item, {
              prop: "city",
              class: "mb-4",
              label: _ctx.t('city'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.city,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formQ.city) = $event)),
                  maxlength: "50",
                  size: "default"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode(_component_el_form_item, {
          prop: "address",
          class: "mb-4",
          label: _ctx.t('address'),
          rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formQ.address,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formQ.address) = $event)),
              size: "default",
              maxlength: "100"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_form_item, {
              prop: "postalcode",
              class: "mb-4",
              label: _ctx.t('postalCode'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.postalcode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formQ.postalcode) = $event)),
                  size: "default",
                  maxlength: "10"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_form_item, {
              prop: "phonecode",
              class: "mb-4",
              label: _ctx.t('telephones'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formQ.phonecode,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formQ.phonecode) = $event)),
                  filterable: "",
                  placeholder: "Seleccione",
                  size: "default"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.idcountry,
                        label: `${item.name} ${item.postalcode}`,
                        value: item.idcountry
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_form_item, {
              prop: "phone1",
              class: "mb-4",
              label: "Teléfono #1",
              rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.phone1,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formQ.phone1) = $event)),
                  size: "default",
                  maxlength: "20"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_form_item, {
              prop: "phone2",
              class: "mb-5",
              label: "Teléfono #2",
              rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.phone2,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formQ.phone2) = $event)),
                  size: "default",
                  maxlength: "20"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rules"])
          ])
        ]),
        _createVNode(_component_el_form_item, {
          prop: "email",
          class: "mb-10",
          label: "Correo eletrónico institucional",
          rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formQ.email,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formQ.email) = $event)),
              size: "default",
              maxlength: "100"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.t("ContactPerson")), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_form_item, {
              prop: "firstname",
              class: "mb-4",
              label: _ctx.t('FamilyName'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.firstname,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formQ.firstname) = $event)),
                  size: "default",
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_form_item, {
              prop: "lastname",
              class: "mb-4",
              label: _ctx.t('GivenName'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.lastname,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formQ.lastname) = $event)),
                  size: "default",
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode(_component_el_form_item, {
          prop: "nfunction",
          class: "mb-4",
          label: _ctx.t('function'),
          rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formQ.nfunction,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formQ.nfunction) = $event)),
              size: "default",
              maxlength: "50"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_form_item, {
              prop: "gender",
              class: "mb-4",
              label: _ctx.t('gender'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formQ.gender,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formQ.gender) = $event)),
                  class: "w-100",
                  size: "default"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGender, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: index,
                        class: "mb-0",
                        label: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_form_item, {
              prop: "cphonecode",
              class: "mb-4",
              label: _ctx.t('Countrycallingcode'),
              rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formQ.cphonecode,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formQ.cphonecode) = $event)),
                  filterable: "",
                  placeholder: "Seleccione",
                  size: "default"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.idcountry,
                        label: `${item.name} ${item.postalcode}`,
                        value: item.idcountry
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_form_item, {
              prop: "cphone1",
              class: "mb-4",
              label: _ctx.t('mobile'),
              rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.cphone1,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formQ.cphone1) = $event)),
                  size: "default",
                  onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleInput('cphone1', $event))),
                  maxlength: "20"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_form_item, {
              prop: "cphone2",
              class: "mb-4",
              label: _ctx.t('oficine'),
              rules: [
                            { required: true, message: 'Requerido', trigger: ['blur', 'change'] },
                            { validator: _ctx.validatePhoneNumber, trigger: ['blur', 'change'] }
                        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formQ.cphone2,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formQ.cphone2) = $event)),
                  size: "default",
                  maxlength: "20"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "rules"])
          ])
        ]),
        _createVNode(_component_el_form_item, {
          prop: "cemail",
          class: "mb-10",
          label: "Correo electrónico",
          rules: { required: true, message: 'Requerido', trigger: ['blur', 'change'] }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formQ.cemail,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formQ.cemail) = $event)),
              size: "default",
              maxlength: "100"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.t("qtitle3")), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.t("sports")), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.t("qtitle4")), 1)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formQ.athletes, (domain, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row text-center bg-white border-bottom bg-hover-light-info",
              key: index
            }, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, _toDisplayString(domain.name), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                (_ctx.accountUser?.idperfil == 1)
                  ? (_openBlock(), _createBlock(_component_el_switch, {
                      key: 0,
                      modelValue: domain.men,
                      "onUpdate:modelValue": ($event: any) => ((domain.men) = $event),
                      "active-value": "1",
                      "inactive-value": "0"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.formQ?.mstatus == 4)
                        ? (_openBlock(), _createBlock(_component_el_switch, {
                            key: 0,
                            modelValue: domain.men,
                            "onUpdate:modelValue": ($event: any) => ((domain.men) = $event),
                            "active-value": "1",
                            "inactive-value": "0"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (domain.men == 1)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_37))
                              : (_openBlock(), _createElementBlock("i", _hoisted_38))
                          ], 64))
                    ], 64))
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}